<template>
  <router-view />
</template>

<script>
export default {
  name: 'AccountsWrapper',
};
</script>
